// extracted by css-extract-rspack-plugin
export default {"cardsContainer":"cardsContainer-MH_xYe","card":"card-JkeM_W","title":"title-fyetNw","subtitle":"subtitle-xcxKIs","links":"links-wvZ9Ww","link":"link-hrvWud"};